import gql from 'graphql-tag';

const WearableActivitySummaryQuery = gql`
  query WearableActivitySummary($dateFrom: Date!, $dateTo: Date!) {
    wearable {
      activitySummary(dateFrom: $dateFrom, dateTo: $dateTo) {
        date
        provider
        device
        steps
        distanceMeters
        floorsClimbed
        elevationMeters
        activeCaloriesKcal
        totalCaloriesKcal
        activeMinutes
        sedentaryMinutes
        lightIntensityMinutes
        moderateIntensityMinutes
        vigorousIntensityMinutes
        heartRateAvgBpm
        heartRateMaxBpm
        heartRateMinBpm
      }
    }
  }
`;

export default WearableActivitySummaryQuery;
